// extracted by mini-css-extract-plugin
module.exports = {"flex":"styles_flex__ZqDGu","path":"styles_path__vhgJL","filler":"styles_filler__1YFHv","soft-validation":"styles_soft-validation__3KXwY","max-width":"styles_max-width__1JrRq"};